// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"f49d78be","787":"fed13e9f"}[chunkId] + ".chunk.js";
};